import { arrayOf, func } from 'prop-types';
import React from 'react';

import { selectOptionPropTypes } from '~propTypes/select';

import styles from './styles.module.scss';

const Options = ({ filteredOptions, handleSelect }) => {
  return (
    <div className={styles.maxHeight}>
      {filteredOptions.map((option) => (
        <div key={option.id} className={styles.option} onClick={() => handleSelect(option)}>
          {option.label}
        </div>
      ))}
    </div>
  );
};

Options.propTypes = {
  filteredOptions: arrayOf(selectOptionPropTypes),
  handleSelect: func
};

export default Options;
